/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DATASET_DEFAULT_READONLY } from '../../../../../../constants/settings';
import { ImportDatasetMeta } from '../../../../../../types/miscellaneous/ImportDatasetMeta';

export const initialImportDatasetMeta: ImportDatasetMeta = {
  readonly: DATASET_DEFAULT_READONLY,
};
